
import { iterate, initialize, tryFind } from "../fable_modules/fable-library-js.5.3.0/Seq.js";
import { equals } from "../fable_modules/fable-library-js.5.3.0/Util.js";
import { toArray } from "../fable_modules/fable-library-js.5.3.0/Option.js";

/**
 * Item ArrowDown moves to: the next item with wraparound, or the first when no item has focus
 */
export function nextIndex(itemCount, focusedIndex_1) {
    let i;
    if (itemCount <= 0) {
        return undefined;
    }
    else {
        let matchResult, i_1;
        if (focusedIndex_1 != null) {
            if ((i = (focusedIndex_1 | 0), (i >= 0) && (i < itemCount))) {
                matchResult = 0;
                i_1 = focusedIndex_1;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return (i_1 + 1) % itemCount;
            default:
                return 0;
        }
    }
}

/**
 * Item ArrowUp moves to: the previous item with wraparound, or the last when no item has focus
 */
export function prevIndex(itemCount, focusedIndex_1) {
    let i;
    if (itemCount <= 0) {
        return undefined;
    }
    else {
        let matchResult, i_1;
        if (focusedIndex_1 != null) {
            if ((i = (focusedIndex_1 | 0), (i > 0) && (i < itemCount))) {
                matchResult = 0;
                i_1 = focusedIndex_1;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return i_1 - 1;
            default:
                return itemCount - 1;
        }
    }
}

/**
 * Item Home moves to
 */
export function firstIndex(itemCount) {
    if (itemCount > 0) {
        return 0;
    }
    else {
        return undefined;
    }
}

/**
 * Item End moves to
 */
export function lastIndex(itemCount) {
    if (itemCount > 0) {
        return itemCount - 1;
    }
    else {
        return undefined;
    }
}

function menuItems(container) {
    return container.querySelectorAll("[role=\'menuitem\']");
}

function focusedIndex(items) {
    const current = document.activeElement;
    return tryFind((i) => equals(items[i], current), initialize(items.length, (x) => (x | 0)));
}

function focusAt(items, index) {
    iterate((i) => {
        (items[i]).focus();
    }, toArray(index));
}

/**
 * Focus the next menu item with wraparound, or the first if none is focused
 */
export function focusNext(container) {
    const items = menuItems(container);
    focusAt(items, nextIndex(items.length, focusedIndex(items)));
}

/**
 * Focus the previous menu item with wraparound, or the last if none is focused
 */
export function focusPrev(container) {
    const items = menuItems(container);
    focusAt(items, prevIndex(items.length, focusedIndex(items)));
}

/**
 * Focus the first menu item
 */
export function focusFirst(container) {
    const items = menuItems(container);
    focusAt(items, firstIndex(items.length));
}

/**
 * Focus the last menu item
 */
export function focusLast(container) {
    const items = menuItems(container);
    focusAt(items, lastIndex(items.length));
}

//# sourceMappingURL=MenuKeyboard.js.map
